import * as Yup from 'yup';

export const formConstants = {
  name: {
    label: 'Name',
    name: 'name',
  },
  website: {
    label: 'Website',
    name: 'website',
  },
  industry: {
    label: 'End-Use Industry',
    name: 'industry',
  },
  militaryUse: {
    label: 'Military End-Use',
    name: 'militaryUse',
  },
  dpas: {
    label: 'DPAS Rating',
    name: 'dpas',
  },
};

export const formValidation = Yup.object().shape({
  [formConstants.name.name]: Yup.string().required(
    `${formConstants.name.label} is required`
  ),
  [formConstants.website.name]: Yup.string(),
  [formConstants.industry.name]: Yup.string().nullable(),
  [formConstants.militaryUse.name]: Yup.boolean(),
  [formConstants.dpas.name]: Yup.string().nullable(),
});

export const formDefaultValues = {
  [formConstants.name.name]: '',
  [formConstants.website.name]: '',
  [formConstants.industry.name]: '',
  [formConstants.dpas.name]: '',
  [formConstants.militaryUse.name]: false,
};
